import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {useNavContext} from '../../../components/NavContextProvider';
import {useActiveProductId} from '../../../shellRemote';
import type {PromptContextParams} from './buildPromptContext';

/**
 * usePromptContextParams returns the route scope, app path, query string, and
 * product ID that every user message derives its page state from.
 */
export function usePromptContextParams(): PromptContextParams {
  const {params} = useNavContext();
  const {pathname: appPath, search} = useLocation();
  const productId = useActiveProductId();
  return useMemo(
    () => ({...params, appPath, search, productId}),
    [params, appPath, search, productId]
  );
}
